var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 11,
    viewBox: "0 0 24 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0488 8.49109H20.5713C19.7019 3.42698 16.8187 0.846375 11.9186 0.846375C7.09792 0.846375 4.13535 3.4711 3.26581 8.49109H1.80261C0.466357 8.49109 0.466304 8.77206 0.466309 9.41173C0.466314 10.2484 1.67565 10.1026 2.06986 10.1026H3.85864C4.21466 10.1026 4.49122 9.82662 4.53096 9.41173C5.1238 4.71413 7.53336 2.4581 11.9203 2.4581C16.2656 2.4581 18.6767 4.71422 19.2697 9.36524C19.2697 9.82643 19.586 10.1488 19.9802 10.1488H23.0488C23.4446 10.1488 23.6919 9.67576 23.6919 9.21635C23.6934 8.75516 23.4446 8.49109 23.0488 8.49109Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71169 5.65912C7.43513 5.65912 7.23804 5.88883 7.23804 6.21111C7.23804 6.53342 7.43514 6.76311 7.71169 6.76311C7.98824 6.76311 8.18534 6.5334 8.18534 6.21111C8.18534 5.88881 7.98823 5.65912 7.71169 5.65912Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0216 5.93536C15.0216 5.33704 14.6259 4.87585 14.1125 4.87585C13.5991 4.87585 13.2034 5.33704 13.2034 5.93536C13.2034 6.53367 13.5991 6.99486 14.1125 6.99486C14.6259 6.99486 15.0216 6.53367 15.0216 5.93536Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9407 8.37471C11.9407 10.2177 9.56934 10.2177 9.56934 8.37471C9.56934 6.53346 11.9407 6.53346 11.9407 8.37471Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7154 5.56656C11.3083 5.56656 11.782 5.01457 11.782 4.32363C11.782 3.63269 11.3083 3.08069 10.7154 3.08069C10.1226 3.08069 9.64893 3.63269 9.64893 4.32363C9.64893 5.01457 10.1226 5.56656 10.7154 5.56656Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5111 6.21115C17.5111 7.25465 16.1665 7.25465 16.1665 6.21115C16.1665 5.16765 17.5111 5.16765 17.5111 6.21115Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7458 8.69696C14.2324 8.69696 13.8367 9.15815 13.8367 9.75646C13.8367 10.3548 14.2324 10.816 14.7458 10.816C15.2592 10.816 15.6549 10.3548 15.6549 9.75646C15.6534 9.15815 15.2592 8.69696 14.7458 8.69696Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71326 9.75641C7.71326 11.1685 5.89502 11.1685 5.89502 9.75641C5.89502 8.3443 7.71326 8.3443 7.71326 9.75641Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0759 8.74347C16.7994 8.74347 16.6023 8.97318 16.6023 9.29547C16.6023 9.61775 16.7994 9.84746 17.0759 9.84746C17.3525 9.84746 17.5496 9.61775 17.5496 9.29547C17.5496 8.97494 17.3525 8.74347 17.0759 8.74347Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcne);
export default __webpack_public_path__ + "static/media/Acne.5514113942ec91f947bbd9d76c34a2cc.svg";
export { ForwardRef as ReactComponent };